"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Row(_ref) {
  var _data = _ref._data,
      children = _ref.children,
      data = _ref.data;

  try {
    return /*#__PURE__*/_react["default"].createElement("tbody", {
      className: _defaultModule["default"]['row'],
      "data-locator": _data
    }, /*#__PURE__*/_react["default"].createElement("tr", {
      className: _defaultModule["default"]['line']
    }, _react["default"].Children.map(children, function (Child, index) {
      return /*#__PURE__*/_react["default"].cloneElement(Child, {
        _index: index,
        _parent: _data,
        _model: data
      });
    })));
  } catch (e) {
    throw e;
  }
}

Row.defaultProps = {
  _data: '',
  data: null
};
var _default = Row;
exports["default"] = _default;